export default __webpack_public_path__ + "static/media/espago-screenshot-05.82a03809.png";